import styled from "styled-components";


export const ArticleContainer = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
export const ArticleContent = styled.div.attrs({})`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const ArticleSection = styled.div.attrs({})`
  display: flex;
  gap: 16px;
  flex-direction: column;
  padding: 16px;
`;
export const ArticleTitle = styled.div.attrs({})`
  color: ${p => p.theme.palette.colors.black};
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
`;
export const ArticleText = styled.div.attrs({})`
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  color: ${p => p.theme.palette.colors.black};

  h1{
    font-family: Lato;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
  }
`;

export const BannerContainer = styled.div.attrs({})`
  position: relative;
  aspect-ratio: 94 / 32;
  background: url(${props => props.bgImage}) center/cover no-repeat;
  display: flex;
  align-items: center;
  transition: background-image 0.8s ease-in-out;
  flex: 1;
  @media (max-width: 718px) {
    aspect-ratio: 16 / 14;
    
    background-size: cover;
  }
`;

export const OptionsIcon = styled.div.attrs({})`
  padding: 7px 6px;
  background: ${p => p.theme.palette.colors.lightBlue};
  border-radius: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ContentContainer = styled.div.attrs({})`
  display: flex;
  gap: 16px;
  align-items: center;
`;
